export default __webpack_public_path__ + "static/media/SndLowerOKeepGoing.294029e0.mp3";